"use client";

import { SizesUI } from "./SizesUI";
import { StandardProps } from "../componentMap";
import { hasSizes } from "../../utils/product/hasSizes";
import { FitToolAndSizeChart } from "../FitToolAndSizeChart/FitToolAndSizeChart";
import { useAvailableSizes } from "./utils";
import { SizeAndFitCta } from "../SizeAndFitCta/SizeAndFitCta";
import { ButtonSizeThreshold } from "./types";

export function Sizes({
  product,
  configProps,
  runtimeConfig,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "runtimeConfig" | "flags">) {
  const isGroupingAllowed = configProps?.allowGrouping === true;
  const isSortingEnabled = configProps?.sortSizes === true;
  const showMore =
    typeof configProps?.showMore === "number"
      ? configProps?.showMore
      : undefined;
  const buttonSizeStyleThreshold =
    typeof configProps?.buttonSizeStyleThreshold === "object" &&
    configProps?.buttonSizeStyleThreshold !== null
      ? (configProps.buttonSizeStyleThreshold as ButtonSizeThreshold)
      : undefined;
  const { brand } = product;

  const showPromoOnIndicators = !!flags.showPromoOnIndicators.value;

  const sizesList = useAvailableSizes(
    product,
    {
      sortSizes: isSortingEnabled,
    },
    showPromoOnIndicators,
  );

  if (!hasSizes(product)) {
    return null;
  }

  return (
    <>
      {configProps?.withFitToolAndSizeChart ? (
        <FitToolAndSizeChart product={product} runtimeConfig={runtimeConfig} />
      ) : null}
      <SizesUI
        sizes={sizesList}
        isGroupingAllowed={isGroupingAllowed}
        showMore={showMore}
        buttonSizeStyleThreshold={buttonSizeStyleThreshold}
        brand={brand?.name}
      />
      {configProps?.withSizeAndFitCTA ? (
        <SizeAndFitCta product={product} flags={flags} />
      ) : null}
    </>
  );
}
